import { Text, Colors } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { formatInteger } from 'utils/format';

const wrapperStyle = {
  paddingY: 'padding_4',
  paddingX: 'padding_8',
  backgroundColor: Colors.ArmyGreen100,
  borderRadius: '8px',
};

type TProps = {
  projectsCount: number;
};

const TotalProjectsFoundBanner = ({ projectsCount }: TProps) => {
  return (
    <FlexRow sx={wrapperStyle}>
      <Text.BodyBold>
        Search Results Preview - {formatInteger(projectsCount)} active projects
      </Text.BodyBold>
    </FlexRow>
  );
};

export default TotalProjectsFoundBanner;
